import React, { useState } from 'react';
import { Dropdown, MenuProps, Modal } from 'antd';
import { useStore } from '@/app/providers/StoreProvider';
import { useNavigate } from 'react-router';
import ImgOptions from '@/shared/pictures/options.svg';
import ImgClose from '@/shared/pictures/close.svg';


export const TeamMemberOptions = () => {
  const navigate = useNavigate();
  const {teamStore} = useStore();
  const {leaveTeam} = teamStore;

  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleCancel = () => {
    setIsModalOpen(false);
  };
  const handleDelete = () => {
    leaveTeam(null);
    setIsModalOpen(false);
    navigate('/menu/teams');
  };

  const items: MenuProps['items'] = [
    {
      label: (
        <div className='team-options_default team-options_red' onClick={()=>{setIsModalOpen(true)}}>
          Покинуть команду
        </div>

      ),
      key: '0',
    },
  ];
  return (
    <>
      <Dropdown menu={{items}} trigger={['click']}>
        <img className='team-options' src={ImgOptions} alt="options" />
      </Dropdown>

      <Modal
      title = {null}
      closable={{ 'aria-label': 'Custom Close Button' }}
      open={isModalOpen}
      footer={null}
      closeIcon={<img src={ImgClose} onClick={()=>handleCancel()}/>}
      >
      <div className='modal'>
        <div className='modal_body'>
          <h3 className='modal_title'>Вы уверены что хотите покинуть команду?</h3>
          <p className='modal_text'>Вы больше не сможете получать бонусы и участвовать в битве кланов</p>
        </div>
        <div className='modal_buttons'>
          <button type='button' className='modal_button button_red' onClick={handleDelete}>Да, покинуть</button>
          <button type='button' className='modal_button button_gray' onClick={handleCancel}>Закрыть</button>
        </div>
      </div>
      </Modal>
    </>
  );
};
